import { render } from "./TestimonialSection.vue?vue&type=template&id=6a2102ad&scoped=true"
import script from "./TestimonialSection.vue?vue&type=script&lang=js"
export * from "./TestimonialSection.vue?vue&type=script&lang=js"

import "./TestimonialSection.vue?vue&type=style&index=0&id=6a2102ad&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2102ad"]])

export default __exports__